// types
import sessionActionTypes from '../action_types/session-action-types'

export const setLogOut = () => ({
	type: sessionActionTypes.resetUserInfo
})

export const setUserInfo = payload => ({
	type: sessionActionTypes.setUserInfo,
	payload
})

export const updatePathologyUser = payload => ({
	type: sessionActionTypes.updatePathologyUser,
	payload
})

export const setPatientToUSer = payload => ({
	type: sessionActionTypes.setPatientUser,
	payload
})

export const updateAllPatients = payload => ({
	type: sessionActionTypes.updateAllPatientsToUser,
	payload
})

export const updatePatients = payload => ({
	type: sessionActionTypes.updatePatientToUser,
	payload
})

export const setServiceUser = payload => ({
	type: sessionActionTypes.setServiceUser,
	payload
})

export const deletePatientToUSer = payload => ({
	type: sessionActionTypes.deletePatientUser,
	payload
})

export const activeSubscription = () => ({
	type: sessionActionTypes.activeSubscription
})
